/**
 * Application Configuration
 * Centralized configuration for API endpoints and environment-specific settings
 */

interface Config {
  API_BASE_URL: string;
  SITE_URL: string;
  ACCOUNT_URL: string;
  ENDPOINTS: {
    CONTACT_FORM: string;
    PRICING: string;
    DETECT_COUNTRY: string;
    GIFT_PURCHASE: string;
  };
}

const isProduction = process.env.NODE_ENV === 'production';

// Get base URLs from environment variables only
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || process.env.API_BASE_URL || '';

const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || '';

const configuredAccountUrl = process.env.NEXT_PUBLIC_ACCOUNT_URL || '';
const ACCOUNT_URL = configuredAccountUrl.replace(
  'https://dev.vibevite.com',
  'https://devweb.vibevite.com',
);

export const config: Config = {
  API_BASE_URL,
  SITE_URL,
  ACCOUNT_URL,
  ENDPOINTS: {
    // Contact form submission
    CONTACT_FORM: `${API_BASE_URL}/contact-form/submit`,

    // Pricing endpoints
    PRICING: `${API_BASE_URL}/payment/pricing/public`,

    // Country detection (internal API route)
    DETECT_COUNTRY: '/api/detect-country',

    // Gift purchase
    GIFT_PURCHASE: `${API_BASE_URL}/gift/purchase`,
  },
};

// Helper function to build pricing URL with currency
export const getPricingUrl = (currency: string = 'USD'): string => {
  return `${config.ENDPOINTS.PRICING}/${currency}`;
};

// Returns the URL for the country pricing-info endpoint.
// Accepts ISO 3166-1 alpha-2 (e.g. "US") or alpha-3 (e.g. "USA") codes.
export const getCountryPricingInfoUrl = (countryCode: string): string => {
  return `${API_BASE_URL}/countries/${countryCode}/pricing-info`;
};

// Export individual values for convenience
export const { API_BASE_URL: apiBaseUrl, SITE_URL: siteUrl, ACCOUNT_URL: accountUrl, ENDPOINTS } = config;

// Log configuration in development
if (!isProduction && typeof window === 'undefined') {
  console.log('🔧 Configuration loaded:', {
    API_BASE_URL,
    SITE_URL,
    ACCOUNT_URL,
    NODE_ENV: process.env.NODE_ENV,
  });
}
